import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { PATHS } from 'models/bary-paths.model';
import { SidenavTransporterConfigurationService } from '../../../../services/sidenav-transporter-configuration.service';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-sidebar-accordion-moderator',
  templateUrl: './bary-sidebar-accordion-moderator.component.html',
  styleUrls: ['./bary-sidebar-accordion-moderator.component.scss'],
})
export class BarySidebarAccordionModeratorComponent implements OnInit {
  private readonly sidenavTransporterConfigurationService = inject(SidenavTransporterConfigurationService);

  @Output() goToEvent = new EventEmitter<string>();

  public showDirectionalCodeNavItem = false;

  protected readonly PATHS = PATHS;
  protected readonly FAS = FaDirectiveEnum.FAS;
  @Input() hasAnalytics: boolean = false;

  public ngOnInit(): void {
    this.sidenavTransporterConfigurationService.retrieveConfiguration().subscribe(tc => {
      if (tc?.body?.directionalCodeItem) {
        this.showDirectionalCodeNavItem = true;
      }
    });
  }
}
